// extracted by mini-css-extract-plugin
export var header = "header-module--header--2ea3u";
export var title = "header-module--title--2ZuB5";